require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./masala-dabba-thehistoryofindianspices.json") })
        }
      }, "path---masala-dabba-thehistoryofindianspices");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---masala-dabba-thehistoryofindianspices!./.cache/json/masala-dabba-thehistoryofindianspices.json
// module id = 719
// module chunks = 231608221292675